import APIService from '../api.service';

export const PermissionList = (params) => {
  return APIService.get(`/v01/permissions`, {
    params: {
      ...params
    },
  });
};

export const CreatePermission = (body, config = {}) => {
  return APIService.post(`/v01/permissions`, body, config);
};

export const DeletePermission = (id) => {
    return APIService.delete(`/v01/permissions/${id}`);
};


const PermissionService = {
 PermissionList,
 CreatePermission,
 DeletePermission
};

export default PermissionService;
